/*
 * Handles the options toggles for the reviewer UI list
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/reviewer/reviewerListToggle/reviewerListToggleView",
  "modules/tasks/tasksModel",
], function (Marionette, Messenger, ReviewerListToggleView, TaskModel) {
  "use strict";

  var ReviewerListToggleController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reviewerListToggle";
      this.region = options.region;
    },
    show: function () {
      this.view = new ReviewerListToggleView.reviewerListToggleView();

      this.view.on(
        "show:not:started",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:reviewer:list", TaskModel.STATUS.NOT_STARTED);
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show:in:progress",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:reviewer:list", TaskModel.STATUS.IN_PROGRESS);
            }
          }, this);
        },
        this,
      );

      this.view.on(
        "show:completed",
        function () {
          //save before switching
          Messenger.save(function (success) {
            if (success) {
              Messenger.vent.trigger("show:reviewer:list", TaskModel.STATUS.RECENTLY_COMPLETED);
            }
          }, this);
        },
        this,
      );

      this.showRegion(this.view);
    },
  });

  return ReviewerListToggleController;
});
